import { Injectable } from '@angular/core';
import { SurveyCriteriaService } from '@ex/module/core/services/survey-criteria.service';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { EngagementMetric } from 'src/app/core/data-models/engagement-metric';
import { Entity } from 'src/app/core/data-models/Entity';
import { GeneralService } from 'src/app/core/services/general.service';

@Injectable({
  providedIn: 'root'
})
export class PredefinedMetricsService {

  constructor(private generalService: GeneralService, private surveyCriteriaService: SurveyCriteriaService) { }
  extractMetrics(entity: Entity, allEntities: Entity[], module?: ModuleName) {


    let metrics = [];
    if (module && (module == ModuleName.Engagement || module == ModuleName.Happiness || module == ModuleName.Wellbeing || module == ModuleName.AiReadiness)) {
      let directManagerIdMetric = new EngagementMetric;
      directManagerIdMetric.key = 'DirectManagerId';
      directManagerIdMetric.isCustom = false;
      directManagerIdMetric.isEntity = false;
      directManagerIdMetric.name = this.generalService.engagementMetric.find(m => m.key == directManagerIdMetric.key).name;
      directManagerIdMetric.required = true;
      directManagerIdMetric.type = 'TEXT';
      directManagerIdMetric.value = '';
      directManagerIdMetric['isSelected'] = true;
      metrics.push(directManagerIdMetric);
    }


    let genderMetric = new EngagementMetric;
    genderMetric.key = 'GENDER';
    genderMetric.isCustom = false;
    genderMetric.isEntity = false;
    genderMetric.name = this.generalService.engagementMetric.find(m => m.key == genderMetric.key).name;
    genderMetric.options = this.generalService.genders_new;
    genderMetric.required = false;
    genderMetric.type = 'DROPDOWN';
    genderMetric.value = '';

    let nationalityMetric = new EngagementMetric;
    nationalityMetric.key = 'NATIONALITY';
    nationalityMetric.isCustom = false;
    nationalityMetric.isEntity = false;
    nationalityMetric.name = this.generalService.engagementMetric.find(m => m.key == nationalityMetric.key).name;
    nationalityMetric.options = this.generalService.countries_new;
    nationalityMetric.required = false;
    nationalityMetric.type = 'DROPDOWN';
    nationalityMetric.value = '';

    let dateOfBirthMetric = new EngagementMetric;
    dateOfBirthMetric.key = 'DOB';
    dateOfBirthMetric.isCustom = false;
    dateOfBirthMetric.isEntity = false;
    dateOfBirthMetric.name = this.generalService.engagementMetric.find(m => m.key == dateOfBirthMetric.key).name;
    dateOfBirthMetric.required = false;
    dateOfBirthMetric.type = 'DATE';
    dateOfBirthMetric.value = '';

    let joiningDateMetric = new EngagementMetric;
    joiningDateMetric.key = 'JOD';
    joiningDateMetric.isCustom = false;
    joiningDateMetric.isEntity = false;
    joiningDateMetric.name = this.generalService.engagementMetric.find(m => m.key == joiningDateMetric.key).name;
    joiningDateMetric.required = false;
    joiningDateMetric.type = 'DATE';
    joiningDateMetric.value = '';

    metrics.push(genderMetric);
    metrics.push(nationalityMetric);
    metrics.push(dateOfBirthMetric);
    metrics.push(joiningDateMetric);

    entity.EntityGroups = entity.EntityGroups?.filter(x => !x.isDeleted) ?? [];
    for (let i = 0; i < entity.EntityGroups.length; i++) {
      let entityGroup = entity.EntityGroups[i];
      if (!entityGroup.isCompanyGroup && allEntities.find(e => e.entityGroupKey == entityGroup.groupKey)) {
        let metric = new EngagementMetric();
        metric.key = entityGroup.groupKey;
        metric.isEntity = true;
        metric.isCustom = false;
        metric.isDeleted = entityGroup.isDeleted;
        metric.name = entityGroup.name;
        metric.options = allEntities.filter(e => e.entityGroupKey == entityGroup.groupKey && !e.isDeleted);
        metrics.push(metric);
      }
    }

    if (entity.PerformanceRates?.length > 0) {
      let metric = new EngagementMetric();
      metric.key = 'PERFORMANCE';
      metric.isEntity = false;
      metric.isCustom = false;
      metric.name = this.generalService.engagementMetric.find(m => m.key == metric.key).name;
      entity.PerformanceRates = entity.PerformanceRates.filter(x => !x.isDeleted);
      for (let i = 0; i < entity.PerformanceRates.length; i++) {
        let option = { key: entity.PerformanceRates[i].key, name: [{ key: '', name: entity.PerformanceRates[i].value }] };
        metric.options.push(option);
      }

      metrics.push(metric);
    }

    if (entity.BandLevels?.length > 0) {
      let metric = new EngagementMetric();
      metric.key = 'BANDLEVEL';
      metric.isEntity = false;
      metric.isCustom = false;
      metric.name = this.generalService.engagementMetric.find(m => m.key == metric.key).name;
      metric.options = entity.BandLevels.filter(x => !x.isDeleted);
      metrics.push(metric);
    }

    if (entity.JobGrades?.length > 0) {
      let metric = new EngagementMetric();
      metric.key = 'JOBGRADE';
      metric.isEntity = false;
      metric.isCustom = false;
      metric.name = this.generalService.engagementMetric.find(m => m.key == metric.key).name;
      metric.options = entity.JobGrades.filter(x => !x.isDeleted);
      metrics.push(metric);
    }

    const availableMetrics = entity?.metrics?.filter(x => !x.isDeleted);
    for (let x = 0; x < availableMetrics?.length; x++) {
      let metric: EngagementMetric = availableMetrics[x];
      if (metric.key == 'GENDER') {
        genderMetric.options = metric.options;
        // genderMetric.isCustom = true;
      } else if (metric.key == 'NATIONALITY') {
        nationalityMetric.options = metric.options;
        // nationalityMetric.isCustom = true;
      } else {
        metric.options = metric?.options?.filter(x => !x?.isDeleted);
        metrics.push(metric);
      }
    }

    return metrics;
  }


  extractAndOverrideMetrics(metrics: any[], entity: Entity, allEntities: Entity[], entityRegistrationRequired: boolean = false) {

    if (entityRegistrationRequired)
      this.generalService.registerEntity(entity);

    const predefinedMetrics = this.extractMetrics(entity, allEntities);
    return metrics.map(metric => {
      const predefineMetric = predefinedMetrics.find(x => x.key == metric.key);
      if (!predefineMetric)
        return metric;

      metric.options = metric.options.map(option => {
        const opt = predefineMetric.options.find(x => x.key == option.key);
        if (opt)
          return opt
        return option;
      })
      const newOptions = predefineMetric.options.filter(x => !metric.options.find(m => m.key == x.key));
      metric.options = [...metric.options, ...newOptions].filter(x => !x.isDeleted);
      return metric;
    });

  }

  extractMetricsWithOptions(entity: Entity, allEntities: Entity[], addDisplayCriteria: boolean = false) {
    var metrics = this.extractMetrics(entity, allEntities);
    return this.surveyCriteriaService.process(metrics, addDisplayCriteria);
  }

}
